//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[[],"GetObject",{R_:{camObject:"CAM.CAMObject"}},0,0],[[],"GetResult",{R_:{response:''}},0,0]],[]];
SPLM.CAM.ToolpathGenerateResult = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolpathGenerateResult";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ToolpathGenerateResult.Types = Object.freeze({
    "Success" : "Success", "Failure" : "Failure"});

export default SPLM;